module.exports = __webpack_public_path__ + "img/pic9.382060aa.png";